import sample_2 from './100_19429.jpg';
import sample_3 from './Olymp_Regular_Fit.jpg';

export const olympRegularFitImpressions = {
    sample_2,
    sample_3,
};
